import {
  callApiLayDanhSachTemplate,
  callApiLayChiTietTemplate,
  callApiThemMoiTemplate,
  callApiSuaTemplate,
  callApiXoaTemplate,
  callApiLayDanhSachQuanLyHeThongLog,
  callApiLayDanhSachDanhMucCRUD,
  callApiLayDanhSachDanhMucCRUDByCode,
  callApiTaoMoiDanhMucCRUDByCode,
  callApiXoaDanhMucCRUDByCode,
  callApiSuaDanhMucCRUDByCode,
} from "@/api/quan-ly-template";

const layDanhSachTemplate = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachTemplate(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_TEMPLATE", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietTemplate = (context, templateId) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietTemplate(templateId)
      .then((response) => {
        if (response) {
          context.commit("SET_CHI_TIET_TEMPLATE", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themMoiTemplate = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiTemplate(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaTemplate = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaTemplate(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaTemplate = (context, templateId) => {
  return new Promise((resolve, reject) => {
    callApiXoaTemplate(templateId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const layDanhSachQuanLyHeThongLog = (context, templateId) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachQuanLyHeThongLog(templateId)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_HE_THONG_LOG", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const LayDanhSachDanhMucCRUD = (context, templateId) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDanhMucCRUD(templateId)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_HE_THONG_CRUD", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const layDanhSachDanhMucCRUDByCode = (context, templateId) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDanhMucCRUDByCode(templateId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const taoMoiDanhMucCRUDByCode = (context, templateId) => {
  return new Promise((resolve, reject) => {
    callApiTaoMoiDanhMucCRUDByCode(templateId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const xoaDanhMucCRUDByCode = (context, templateId) => {
  return new Promise((resolve, reject) => {
    callApiXoaDanhMucCRUDByCode(templateId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const suaDanhMucCRUDByCode = (context, templateId) => {
  return new Promise((resolve, reject) => {
    callApiSuaDanhMucCRUDByCode(templateId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  layDanhSachTemplate,
  layChiTietTemplate,
  themMoiTemplate,
  suaTemplate,
  xoaTemplate,
  layDanhSachQuanLyHeThongLog,
  LayDanhSachDanhMucCRUD,
  layDanhSachDanhMucCRUDByCode,
  taoMoiDanhMucCRUDByCode,
  xoaDanhMucCRUDByCode,
  suaDanhMucCRUDByCode,
};
